<template>
  <router-view />
</template>

<script>
export default {
  name: "app",
};
</script>

<style>
#silentbox-overlay__background {
  background: rgba(54, 69, 99, 0.8) !important;
  backdrop-filter: none !important;
}
#silentbox-overlay__close-button {
  right: 18px !important;
}
#silentbox-overlay__embed img,
#silentbox-overlay__embed iframe,
#silentbox-overlay__container,
#silentbox-overlay__embed {
  pointer-events: none;
}
#silentbox-overlay__embed iframe {
  pointer-events: all;
}
</style>
